import {EmbodeeService} from "../../api/services/embodeeService";
import {getEmbodeeGridwallImage} from "../../helpers/embodeeHelpers";

interface Inspiration {
  key: string;
  id: string;
}

/**
 * Returns image src specifically for JBA (DIGITAL/CUSTOM/DQT) products, both thumbnail and full size images
 */
export const getGridImageEmbodeeUrl = (inspiration: Inspiration, imageType: string, bodyType='top') => {
  bodyType = bodyType.toLowerCase()
  let zoom = bodyType === 'top' ? '1.0' : '0.8';
  let isDefault = inspiration.id === "";
  return getEmbodeeGridwallImage(isDefault ? inspiration.key : inspiration.id, imageType, bodyType, zoom);
};

/**
 * Retrieves set of inspirations for a given JBA (DIGITAL/CUSTOM/DQT) product
 */
export const getInspirationImageUrls = (styleNumber: string): Promise<Inspiration[]> => {
  return new Promise(resolve => {
    EmbodeeService.getInspirationsByStyle(styleNumber).then(function(response) {
      if(response && response.result && response.result.length > 0) {
        resolve(response.result);
      } else {
        resolve([]);
      }
    });
  });
};
